
import { ProductSales } from '@domain/sales/models/Sales';
import { ProductMapper } from '../../product/mappers/ProductMapper';
import { SalesDTO } from '../dto/SalesDTO';

export class WeeklySalesMapper {
    static toModel(dto: SalesDTO): ProductSales {
        return {
            product: ProductMapper.toModel(dto.product),
            forecastGrade: dto.forecastGrade,
            weeks: dto.weeks.map(week => ({
                week: week.week,
                year: week.year,
                sales: {
                    quantity: week.quantity,
                    anomaly: week.anomaly,
                    detectedAnomaly: week.detectedAnomaly
                },
                forecast: {
                    quantity: week.forecastQuantity
                },
            }))
        };
    }
} 